import {
  StreamsState,
  SetLoadingAction,
  SetStreamsAction,
  SetViewersAction,
  SetMessagesAction,
  FetchMessagesAction,
  SendMessageAction,
  SetChatFormTextAction,
  SetIsFinishedAction,
  SetIsSendingMessageAction,
} from './interface';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';

const initialState: StreamsState = {
  isLoading: false,
  streams: [],
  isFinished: false,
  messages: [],
  isMessagesLoading: true,
  isSendingMessage: false,
  viewers: 0,
  chatFormText: '',
};

export const { actions, reducer } = createSlice({
  name: 'streams',
  initialState,
  reducers: {
    setLoading(state, action: SetLoadingAction) {
      state.isLoading = action.payload;
    },
    setStreams(state, action: SetStreamsAction) {
      state.streams = action.payload;
    },
    fetchMessages(state, action: FetchMessagesAction) {},
    setMessages(state, action: SetMessagesAction) {
      state.messages = action.payload;
      state.isMessagesLoading = false;
    },
    setIsSendingMessage(state, action: SetIsSendingMessageAction) {
      state.isSendingMessage = action.payload;
    },
    sendMessage(state, action: SendMessageAction) {
      state.isSendingMessage = true;
    },
    setChatFormText(state, action: SetChatFormTextAction) {
      state.chatFormText = action.payload;
    },
    setViewers(state, action: SetViewersAction) {
      state.viewers = action.payload;
    },
    setIsFinished(state, action: SetIsFinishedAction) {
      state.isFinished = action.payload;
    },
  },
});

export { reducer as streamsReducer, actions as streamsActions };

export const streamsSelector = (state: RootState) => state.streams;
